<template>
  <div>
    <v-menu>
      <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-on:click.prevent
        v-bind="attrs"
        v-on="on"
        data-testid="video-conference-context-menu-btn"
      >
        <v-icon class="pb-2">mdi-dots-vertical</v-icon>
      </v-btn>
      </template>
      <v-list dense>
      <v-list-item
        v-for="(contextMenu, index) in contextMenusWithPermission"
        :key="index"
        style="display: -webkit-box !important;"
        data-testid="video-conference-context-menu-item"
        @click="navigation(contextMenu)"
      >
        <v-list-item-icon>
        <v-icon :color="contextMenu.color">{{contextMenu.icon}}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t(`videoconf.optionsContextMenu.${contextMenu.key}`) }}</v-list-item-title>
      </v-list-item>
      </v-list>
    </v-menu>
    <Form :video-conference="videoConference" :show-form="showForm" :is-update="isUpdate" @close="closeForm()"/>
    <DeleteForm :video-conference="videoConference" :show-form="showDeleteForm" @close="closeDeleteForm()"/>
    <ParticipantDialog :video-conference="videoConference" :show-form="showParticipantsForm" @close="closeParticipantsDialog()"/>
    <AboutDialog :video-conference="videoConference" :show-form="showAboutForm" @close="closeAboutDialog()"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VideoConference from 'Store/class/video_conference'
import Form from './form'
import DeleteForm from './delete_dialog'
import ParticipantDialog from './participants_dialog'
import AboutDialog from './about_dialog'

export default {
  name: 'video-conference-item-context-menu',
  components: { Form, DeleteForm, ParticipantDialog, AboutDialog },
  data () {
    return {
      showForm: false,
      showDeleteForm: false,
      showParticipantsForm: false,
      showAboutForm: false,
      isUpdate: false,
      contextMenus: [
        { key: 'update', icon: 'mdi-pencil', color: 'default' },
        { key: 'seeParticipants', icon: 'mdi-account-group', color: 'default' },
        { key: 'about', icon: 'mdi-information', color: 'default' },
        { key: 'delete', icon: 'mdi-delete', color: 'red' }
      ]
    }
  },
  props: {
    videoConference: { type: VideoConference, default: new VideoConference() }
  },
  computed: {
    ...mapGetters({
      canVideoConferencesWrite: 'permissions/videoConfWrite'
    }),

    contextMenusWithPermission: function () {
      if (this.canVideoConferencesWrite) {
        return this.contextMenus
      } else {
        return [this.contextMenus[1]]
      }
    }
  },
  methods: {
    navigation (contextMenu) {
      switch (contextMenu.key) {
        case 'update':
          this.openForm(true)
          break
        case 'delete':
          this.openDeleteForm()
          break
        case 'seeParticipants':
          this.openParticipantsDialog()
          break
        case 'about':
          this.openAboutDialog()
          break
      }
    },
    openForm (isUpdate) {
      this.isUpdate = isUpdate
      this.showForm = true
    },
    closeForm () {
      this.showForm = false
    },
    openDeleteForm () {
      this.showDeleteForm = true
    },
    closeDeleteForm () {
      this.showDeleteForm = false
    },
    openParticipantsDialog () {
      this.showParticipantsForm = true
    },
    closeParticipantsDialog () {
      this.showParticipantsForm = false
    },
    openAboutDialog () {
      this.showAboutForm = true
    },
    closeAboutDialog () {
      this.showAboutForm = false
    }
  }
}
</script>

<style>

</style>
